import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useAuth } from './AuthContext';

interface AppReadyContextType {
  isAppReady: boolean;
  setAppReady: (ready: boolean) => void;
}

const AppReadyContext = createContext<AppReadyContextType | undefined>(undefined);

export const useAppReady = () => {
  const context = useContext(AppReadyContext);
  if (context === undefined) {
    throw new Error('useAppReady must be used within an AppReadyProvider');
  }
  return context;
};

interface AppReadyProviderProps {
  children: ReactNode;
}

export const AppReadyProvider: React.FC<AppReadyProviderProps> = ({ children }) => {
  const [isAppReady, setAppReadyState] = useState(false);
  const { user } = useAuth();

  // Reset quando o usuário faz logout para que no próximo login o splash apareça de novo
  useEffect(() => {
    if (!user) {
      setAppReadyState(false);
    }
  }, [user]);

  const setAppReady = (ready: boolean) => {
    setAppReadyState(ready);
  };

  const value: AppReadyContextType = {
    isAppReady,
    setAppReady,
  };

  return (
    <AppReadyContext.Provider value={value}>
      {children}
    </AppReadyContext.Provider>
  );
};
